import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8v8","key":"svg-0"}],["path",{"d":"M20 16v-8","key":"svg-1"}],["path",{"d":"M8 4h8","key":"svg-2"}],["path",{"d":"M8 20h8","key":"svg-3"}]]

const IconBorderSides = createReactComponent('outline', 'border-sides', 'BorderSides', __iconNode);

export default IconBorderSides;